import React, {
    useState
} from "react"
import {
    Typography,
    IconButton,
    Tooltip,
    useTheme,
    useMediaQuery,
    Checkbox,
    List,
    ListItemButton,
    ListItemText,
    Button,
    Modal
} from "@mui/material"
import {
    Close,
    Download
} from "@mui/icons-material"
import _ from "lodash"
import useStyles from "./styles"


export default function ManageFee({
    isOpen = false,
    onClose,
    data = null,
    handleUpdatePayment,
    studentPaidData = [],
    downloadFeeReceipt
}) {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const [selectedFees, setSelectedFees] = useState([])

    const feeStructure = _.get(data, "meta_data.feeStructure", [])
    function handleUpdate() {
        let collections = []
        if (selectedFees.length > 0 && Array.isArray(feeStructure) && feeStructure.length > 0) {
            feeStructure.map((fee) => {
                if (selectedFees.includes(fee.feeName)) {
                    collections.push({ ...fee })
                }
            })
        }
        handleUpdatePayment({ collections: collections })
        setSelectedFees([])
    }

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            classes={{ root: classes.popover_root }}
        >
            <div style={{
                width: isMobile ? "100%" : "400px",
                height: "500px",
                border: "1px solid gray",
                backgroundColor: "#000",
                borderRadius: "12px"
            }}>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#FFFF",
                    padding: "4px",
                    borderTopRightRadius: "12px",
                    borderTopLeftRadius: "12px"
                }}>
                    <Typography>Update Admission Fee</Typography>
                    <Tooltip title={"Close"} arrow placement="bottom">
                        <IconButton onClick={onClose}>
                            <Close />
                        </IconButton>
                    </Tooltip>
                </div>
                <div style={{
                    height: "80%",
                    backgroundColor: "#ccb4b4ff",
                    width: "100%",
                    padding: "10px",
                    overflowY: "scroll"
                }}>
                    {
                        Array.isArray(feeStructure) && feeStructure.length > 0 && (
                            <List classes={{ root: classes.list }}>
                                {
                                    feeStructure.map((item, index) => {
                                        let isPaid = selectedFees.includes(item.feeName)
                                        let isAlreadyPaid = studentPaidData.find((i) => i.fee_name === item.feeName)
                                        if (isAlreadyPaid) {
                                            isPaid = true
                                        }
                                        return (
                                            <ListItemButton key={index} disabled={isAlreadyPaid} onClick={() => {
                                                const isSelected = selectedFees.includes(item.feeName)
                                                if (isSelected) {
                                                    const removeList = selectedFees.filter(fee => fee !== item.feeName)
                                                    setSelectedFees([...removeList])
                                                } else {
                                                    setSelectedFees([...selectedFees, item.feeName])
                                                }
                                            }}>
                                                <ListItemText primary={`(${item.feeName})`} classes={{ root: classes.listText }} />
                                                <ListItemText primary={`Rs - ${item.feeAmount}`} classes={{ root: classes.listText }} />
                                                <Checkbox
                                                    color="primary"
                                                    checked={isPaid}
                                                //    disabled = {isAlreadyPaid}
                                                />
                                            </ListItemButton>
                                        )
                                    })
                                }
                            </List>
                        )
                    }
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: "center",
                    padding: "8px",
                    gap: "8px"
                }}>
                    <Button
                        size="small"
                        variant="text"
                        onClick={onClose}
                    >Cancel</Button>
                    <Button
                        startIcon={<Download />}
                        size="small"
                        variant="contained"
                        onClick={() => {
                            downloadFeeReceipt(studentPaidData)
                        }}
                    >
                        Download
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={handleUpdate}
                    >
                        submit
                    </Button>
                </div>
            </div>
        </Modal>
    )
}